import {
    ADD_MEMBER_DATE_FORMAT,
    ADD_MEMBER_FIELD_LIMITS,
} from "../../Utils/family-tree/addMemberFieldLimits";
import { getPhoneInputValue, phoneInputCountrySearchProps } from "../../Utils/phone";
import {
    isEditModeMinor,
} from "../../Utils/family-tree/memberAge";
import { isInRelationshipMaritalStatus } from "../../Utils/family-tree/dropdown";

export function AdditionalSpouseSection({
    spouses,
    toggleSpouseSection,
    removeAdditionalSpouse,
    openSpouseSections,
    uploadedImages,
    removeImage,
    handleFileChange,
    additionalSpouseImageErrors,
    DropdownSelect,
    sortedGenderOptions,
    handleAdditionalSpouseChange,
    setAdditionalSpouseErrors,
    additionalSpouseErrors,
    touchedFields,
    formSubmitted,
    setTouchedFields,
    CustomDatePicker,
    dateValidationErrors,
    sortedStates,
    sortedLivingDeceasedOptions,
    sortedDivorceOptions,
    emailCheckTimeoutRef,
    checkEmailExists,
    handlePhoneChange,
    PhoneInput,
    sortedCellTypeOptions,
    handleAdditionalSpousePhoneChange,
    grandfatherData,
    setSpouseValidationErrors,
    isEditMode = false,
}) {
    const skipMaritalFieldRequirements = [3, 4].includes(
        Number(grandfatherData.maritalStatus)
    );
    const isInRelationship = isInRelationshipMaritalStatus(
        grandfatherData.maritalStatus
    );

    return (
        <>
            {/* ADDITIONAL SPOUSE SECTIONS - All spouses beyond the first one */}
            {spouses.slice(1).map((spouse, index) => {
                const isSpouseMinor = isEditModeMinor({
                    isEditMode,
                    dob: spouse.dob,
                    currentAge: spouse.currentAge,
                    fallbackDob: spouse.originalDob || spouse.dob,
                });
                return (
                <div
                    key={spouse.id}
                    className="section spouse-section addmember-section"
                >
                    <div
                        className="section-header addmember-section-header"
                        onClick={() => toggleSpouseSection(spouse.id)}
                        role="button"
                        tabIndex={0}
                    >
                        <h3>
                            Additional Spouse (Marriage {index + 2})
                            <button
                                type="button"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    removeAdditionalSpouse(spouse.id);
                                }}
                                className="remove-spouse-btn"
                                style={{
                                    marginLeft: "10px",
                                    background: "#ff4444",
                                    color: "white",
                                    border: "none",
                                    borderRadius: "3px",
                                    padding: "2px 8px",
                                    fontSize: "12px",
                                    cursor: "pointer",
                                }}
                            >
                                Remove
                            </button>
                        </h3>
                        <span
                            className={`dropdown-icon ${openSpouseSections.includes(spouse.id) ? "rotated" : ""
                                }`}
                        >
                            ▼
                        </span>
                    </div>

                    {openSpouseSections.includes(spouse.id) && (
                        <>
                            {/* Additional Spouse Image Upload */}
                            <div
                                id={`additional-spouse-image-section-${spouse.id}`}
                                className="image-row addmember-image-row"
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "10px",
                                }}
                            >
                                {!uploadedImages.some(
                                    (img) => img.type == `spouse-${spouse.id}`
                                ) && (
                                        <div
                                            style={{
                                                width: "65px",
                                                height: "65px",
                                                overflow: "hidden",
                                                flexShrink: 0,
                                            }}
                                        >
                                            <img
                                                src={window.getPublicUrl("/assets/images/d-user.jpg")}
                                                alt="Additional Spouse"
                                                style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    borderRadius: "50%",
                                                    objectFit: "cover",
                                                }}
                                            />
                                        </div>
                                    )}

                                {uploadedImages
                                    .filter((img) => img.type == `spouse-${spouse.id}`)
                                    .map((img) => (
                                        <div
                                            key={img.id}
                                            style={{
                                                width: "65px",
                                                height: "65px",
                                                overflow: "hidden",
                                                position: "relative",
                                                flexShrink: 0,
                                            }}
                                        >
                                            <img
                                                src={img.url}
                                                alt="Additional Spouse"
                                                style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    borderRadius: "50%",
                                                    objectFit: "cover",
                                                }}
                                            />
                                            <button
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    removeImage(img.id);
                                                }}
                                                style={{
                                                    position: "absolute",
                                                    top: "2px",
                                                    right: "2px",
                                                    background: "rgba(0,0,0,0.5)",
                                                    color: "white",
                                                    border: "none",
                                                    borderRadius: "50%",
                                                    width: "18px",
                                                    height: "18px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    cursor: "pointer",
                                                    fontSize: "12px",
                                                    padding: 0,
                                                    lineHeight: 1,
                                                }}
                                            >
                                                ×
                                            </button>
                                        </div>
                                    ))}

                                {uploadedImages.filter(
                                    (img) => img.type == `spouse-${spouse.id}`
                                ).length < 2 && (
                                        <div
                                            onClick={() => {
                                                const input = document.createElement("input");
                                                input.type = "file";
                                                input.accept = "image/*";
                                                input.onchange = (e) =>
                                                    handleFileChange(e, `spouse-${spouse.id}`);
                                                input.click();
                                            }}
                                            style={{
                                                cursor: "pointer",
                                                width: "65px",
                                                height: "65px",
                                                borderRadius: "4px",
                                                border: "1px dashed #ccc",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                background: "#f5f5f5",
                                                flexShrink: 0,
                                            }}
                                        >
                                            <span style={{ fontSize: "24px", color: "#666" }}>
                                                +
                                            </span>
                                        </div>
                                    )}
                            </div>
                            {additionalSpouseImageErrors[spouse.id] && (
                                <div
                                    style={{
                                        color: "#ff4d4f",
                                        fontSize: "12px",
                                        marginTop: "4px",
                                    }}
                                >
                                    {additionalSpouseImageErrors[spouse.id]}
                                </div>
                            )}

                            {/* Additional Spouse Form Fields */}
                            <div className="row form-grid addmember-form-grid">

                                <div id={`gender-field-${spouse.id}`} className="form-group addmember-form-group">
                                    <label className="required-label">Gender</label>
                                    <DropdownSelect
                                        options={sortedGenderOptions}
                                        value={spouse.gender}
                                        onChange={(val) => {
                                            const fakeEvent = {
                                                target: { name: "gender", value: val },
                                            };
                                            handleAdditionalSpouseChange(fakeEvent, spouse.id);
                                            // Clear error when value changes
                                            if (val) {
                                                setAdditionalSpouseErrors((prev) => ({
                                                    ...prev,
                                                    [spouse.id]: {
                                                        ...prev[spouse.id],
                                                        gender: "",
                                                    },
                                                }));
                                            }
                                        }}
                                        maxMenuHeight={180}
                                        focusNextOnSelect
                                        maxSearchLength={ADD_MEMBER_FIELD_LIMITS.GENDER}
                                    />
                                    {additionalSpouseErrors[spouse.id]?.gender &&
                                        (touchedFields.spouse.gender || formSubmitted) && (
                                            <div
                                                style={{
                                                    color: "#d32f2f",
                                                    fontSize: "12px",
                                                    marginTop: "4px",
                                                }}
                                            >
                                                {additionalSpouseErrors[spouse.id].gender}
                                            </div>
                                        )}
                                </div>

                                {[
                                    "firstName",
                                    "specialName",
                                    "lastName",
                                    "suffix",
                                    "maidenName",
                                ].map((field) => {
                                    const isRequired = (field === "firstName" || field === "lastName");
                                    const isMaidenNameDisabled = field === "maidenName" && (spouse.gender === "1" || spouse.gender === 1);
                                    const isSuffixDisabled = field === "suffix" && (spouse.gender === "2" || spouse.gender === 2);
                                    const isFieldDisabled = isMaidenNameDisabled || isSuffixDisabled;
                                    return (
                                        <div
                                            className={`form-group addmember-form-group ${field === "specialName" ? "special-initial-field" : ""}`}
                                            key={field}
                                        >
                                            <label
                                                htmlFor={`additional-spouse-${spouse.id}-${field}`}
                                                className={isRequired ? "required-label" : ""}
                                            >
                                                {field === "specialName" ? "Special Initial" : field.replace(/([A-Z])/g, " $1").trim()}
                                            </label>
                                            <input
                                                id={`additional-spouse-${spouse.id}-${field}`}
                                                type="text"
                                                name={field}
                                                value={field === "suffix" 
                                                  ? (() => {
                                                      // Display value with period appended at the end only (UI only)
                                                      const suffixValue = spouse[field] || "";
                                                      if (suffixValue === "") return "";
                                                      // Remove ALL periods from the value, then add one at the end
                                                      const cleanedValue = suffixValue.replace(/\./g, "");
                                                      return cleanedValue + ".";
                                                    })()
                                                  : (spouse[field] || "")}
                                                placeholder={field === "specialName" ? "Put initial to distinguish same first named family members." : ""}
                                                required={isRequired}
                                                disabled={isFieldDisabled}
                                                style={isFieldDisabled ? { backgroundColor: "#f5f5f5", opacity: 0.6, cursor: "not-allowed" } : {}}
                                                onChange={(e) => {
                                                    if (field === "suffix") {
                                                        // Remove ALL periods from input (user can type normally, periods will be removed)
                                                        let inputValue = e.target.value;
                                                        // Remove all periods (user shouldn't type periods, we add it automatically)
                                                        inputValue = inputValue.replace(/\./g, "");
                                                        
                                                        // Update the stored value (without any periods)
                                                        handleAdditionalSpouseChange({
                                                            target: { name: field, value: inputValue },
                                                        }, spouse.id);
                                                    } else {
                                                        handleAdditionalSpouseChange(e, spouse.id);
                                                    }
                                                    // Clear error when value changes
                                                    if (e.target.value.trim() && isRequired) {
                                                        setAdditionalSpouseErrors((prev) => ({
                                                            ...prev,
                                                            [spouse.id]: {
                                                                ...prev[spouse.id],
                                                                [field]: "",
                                                            },
                                                        }));
                                                    }
                                                }}
                                                onBlur={(e) => {
                                                    // Trim the value when user leaves the field
                                                    let trimmedValue = e.target.value.trim();
                                                    
                                                    if (field === "suffix") {
                                                        // Remove ALL periods before storing (we add it only for display)
                                                        trimmedValue = trimmedValue.replace(/\./g, "");
                                                    }
                                                    
                                                    if (trimmedValue !== (field === "suffix" ? spouse[field] : e.target.value)) {
                                                        handleAdditionalSpouseChange({
                                                            target: { name: field, value: trimmedValue },
                                                        }, spouse.id);
                                                    }
                                                    if (isRequired) {
                                                        setTouchedFields((prev) => ({
                                                            ...prev,
                                                            spouse: {
                                                                ...prev.spouse,
                                                                [field]: true,
                                                            },
                                                        }));
                                                    }
                                                }}
                                            />
                                            {isRequired && additionalSpouseErrors[spouse.id]?.[field] &&
                                                (touchedFields.spouse[field] || formSubmitted) && (
                                                    <div
                                                        style={{
                                                            color: "#d32f2f",
                                                            fontSize: "12px",
                                                            marginTop: "4px",
                                                        }}
                                                    >
                                                        {additionalSpouseErrors[spouse.id][field]}
                                                    </div>
                                                )}
                                        </div>
                                    );
                                })}


                                {/* Wedding Anniversary - Show in original position if divorce is not "Yes" */}
                                {grandfatherData.maritalStatus != 1 && spouse.divorce != 1 && (
                                    <>
                                        <div className="form-group addmember-form-group">
                                            <label
                                                className={
                                                    skipMaritalFieldRequirements
                                                        ? ""
                                                        : "required-label"
                                                }
                                            >
                                                Wedding Anniversary
                                            </label>
                                            <CustomDatePicker
                                                value={isInRelationship ? "" : spouse.wedding_anniversary}
                                                onChange={(e) => handleAdditionalSpouseChange(e, spouse.id, index)}
                                                name="wedding_anniversary"
                                                format={ADD_MEMBER_DATE_FORMAT}
                                                autoFocusNextOnComplete
                                                required={!skipMaritalFieldRequirements}
                                                disabled={isInRelationship}
                                                error={
                                                    !!dateValidationErrors?.additional_spouse?.[index]?.wedding_anniversary &&
                                                    (touchedFields?.additional_spouse?.[index]?.wedding_anniversary || formSubmitted)
                                                }
                                                helperText={
                                                    (touchedFields?.additional_spouse?.[index]?.wedding_anniversary || formSubmitted)
                                                        ? dateValidationErrors?.additional_spouse?.[index]?.wedding_anniversary
                                                        : ""
                                                }
                                            />
                                            {/* {dateValidationErrors.spouse.weddingAnniversary && (touchedFields.spouse.weddingAnniversary || formSubmitted) && (
                              <div style={{ color: '#d32f2f', fontSize: '12px', marginTop: '4px' }}>
                                {dateValidationErrors.spouse.weddingAnniversary}
                              </div>
                            )} */}
                                        </div>
                                        {/* Time Married - Show after Wedding Anniversary when divorce is not "Yes" */}
                                        <div className="form-group addmember-form-group">
                                            <label>Time Married</label>
                                            <input
                                                type="text"
                                                name="marriedYears"
                                                value={spouse.marriedYears || ""}
                                                readOnly
                                                placeholder="Auto calculated"
                                                style={{ backgroundColor: "#f0f0f0" }}
                                            />
                                        </div>
                                    </>
                                )}

                                <div className="form-group addmember-form-group">
                                    <label className={isSpouseMinor ? "" : "required-label"}>
                                        Date of Birth
                                    </label>
                                    <CustomDatePicker
                                        value={spouse.dob}
                                        onChange={(e) =>
                                            handleAdditionalSpouseChange(e, spouse.id, index)
                                        }
                                        name="dob"
                                        format={ADD_MEMBER_DATE_FORMAT}
                                        autoFocusNextOnComplete
                                        required={!isSpouseMinor}
                                        error={
                                            !!dateValidationErrors?.additional_spouse?.[index]?.dob &&
                                            (touchedFields?.additional_spouse?.[index]?.dob || formSubmitted)
                                        }
                                        helperText={
                                            (touchedFields?.additional_spouse?.[index]?.dob || formSubmitted)
                                                ? dateValidationErrors?.additional_spouse?.[index]?.dob
                                                : ""
                                        }
                                    />
                                </div>

                                {spouse.aliveStatus == "2" || spouse.ageOfDeath ? (
                                    <div className="form-group addmember-form-group">
                                        <label>Age at Time of Death</label>
                                        <input
                                            type="text"
                                            name="ageOfDeath"
                                            value={spouse.ageOfDeath}
                                            readOnly
                                            placeholder="Auto calculated"
                                            style={{ backgroundColor: "#f0f0f0" }}
                                        />
                                    </div>
                                ) : (
                                    (spouse.aliveStatus == "1" || spouse.currentAge) && (
                                        <div className="form-group addmember-form-group">
                                            <label>Current Age</label>
                                            <input
                                                type="text"
                                                name="currentAge"
                                                value={spouse.currentAge}
                                                readOnly
                                                placeholder="Auto calculated"
                                                style={{ backgroundColor: "#f0f0f0" }}
                                            />
                                        </div>
                                    )
                                )}

                                <div className="form-group addmember-form-group">
                                    <label>Current U.S. State or Country Living</label>
                                    <DropdownSelect
                                        options={sortedStates}
                                        value={spouse.currentStateResiding}
                                        onChange={(val) => {
                                            const fakeEvent = {
                                                target: {
                                                    name: "currentStateResiding",
                                                    value: val,
                                                },
                                            };
                                            handleAdditionalSpouseChange(fakeEvent, spouse.id);
                                        }}
                                        placeholder="Select your current state living"
                                        maxMenuHeight={180}
                                        disabled={spouse.aliveStatus === "2"}
                                    />
                                </div>

                                <div id={`additional-spouse-alive-status-field-${spouse.id}`} className="form-group addmember-form-group">
                                    <label className="required-label">Living / Deceased</label>
                                    <DropdownSelect
                                        options={sortedLivingDeceasedOptions}
                                        value={spouse.aliveStatus}
                                        onChange={(val) => {
                                            const fakeEvent = {
                                                target: { name: "aliveStatus", value: val },
                                            };
                                            handleAdditionalSpouseChange(fakeEvent, spouse.id);
                                            // Clear error when value changes
                                            if (val) {
                                                setAdditionalSpouseErrors((prev) => ({
                                                    ...prev,
                                                    [spouse.id]: {
                                                        ...prev[spouse.id],
                                                        aliveStatus: "",
                                                    },
                                                }));
                                            }
                                            // If Deceased (2) is selected, clear email
                                            // If Living (1) is selected, enable email and make it required
                                            if (val === "2") {
                                                // Deceased: clear email
                                                const emailEvent = {
                                                    target: { name: "email", value: "" },
                                                };
                                                handleAdditionalSpouseChange(emailEvent, spouse.id);
                                                // Clear email validation error
                                                setAdditionalSpouseErrors((prev) => ({
                                                    ...prev,
                                                    [spouse.id]: {
                                                        ...prev[spouse.id],
                                                        email: "",
                                                    },
                                                }));
                                            }
                                        }}
                                        onBlur={() => {
                                            setTouchedFields((prev) => ({
                                                ...prev,
                                                spouse: {
                                                    ...prev.spouse,
                                                    aliveStatus: true,
                                                },
                                            }));
                                        }}
                                        placeholder="Select"
                                        maxMenuHeight={95}
                                    />
                                    {additionalSpouseErrors[spouse.id]?.aliveStatus &&
                                        (touchedFields.spouse.aliveStatus || formSubmitted) && (
                                            <div
                                                style={{
                                                    color: "#d32f2f",
                                                    fontSize: "12px",
                                                    marginTop: "4px",
                                                }}
                                            >
                                                {additionalSpouseErrors[spouse.id].aliveStatus}
                                            </div>
                                        )}
                                </div>

                                {spouse.aliveStatus == "2" && (
                                    <div className="form-group addmember-form-group">
                                        <label>Date of Death</label>
                                        <CustomDatePicker
                                            value={spouse.dod}
                                            onChange={(e) =>
                                                handleAdditionalSpouseChange(e, spouse.id, index)
                                            }
                                            name="dod"
                                            format={ADD_MEMBER_DATE_FORMAT}
                                            autoFocusNextOnComplete
                                            error={
                                                !!dateValidationErrors?.additional_spouse?.[index]?.dod &&
                                                (touchedFields?.additional_spouse?.[index]?.dod || formSubmitted)
                                            }
                                            helperText={
                                                (touchedFields?.additional_spouse?.[index]?.dod || formSubmitted)
                                                    ? dateValidationErrors?.additional_spouse?.[index]?.dod
                                                    : ""
                                            }
                                        />
                                    </div>
                                )}



                                <div id={`additional-spouse-email-field-${spouse.id}`} className="form-group addmember-form-group">
                                    <>
                                        <label>Email</label>
                                        <input
                                                    type="email"
                                                    name="email"
                                                    value={spouse.email}
                                                    placeholder="type in email to get updated notices"
                                                    onChange={(e) => {
                                                        handleAdditionalSpouseChange(e, spouse.id);
                                                        // Clear error when value changes (including when cleared)
                                                        setAdditionalSpouseErrors((prev) => ({
                                                            ...prev,
                                                            [spouse.id]: {
                                                                ...prev[spouse.id],
                                                                email: "",
                                                            },
                                                        }));

                                                        // Debounce email validation
                                                        if (emailCheckTimeoutRef.current) {
                                                            clearTimeout(emailCheckTimeoutRef.current);
                                                        }
                                                        const emailValue = e.target.value.trim();
                                                        if (emailValue) {
                                                            emailCheckTimeoutRef.current = setTimeout(() => {
                                                                console.log("⏰ Debounce timeout triggered (additional spouse), checking email:", emailValue);
                                                                checkEmailExists(emailValue, `additional-${spouse.id}`);
                                                            }, 500); // Wait 500ms after user stops typing
                                                        }
                                                    }}
                                                    onBlur={(e) => {
                                                        // Clear any pending timeout
                                                        if (emailCheckTimeoutRef.current) {
                                                            clearTimeout(emailCheckTimeoutRef.current);
                                                        }

                                                        // Trim the value when user leaves the field
                                                        const trimmedValue = e.target.value.trim();
                                                        if (trimmedValue !== e.target.value) {
                                                            handleAdditionalSpouseChange({
                                                                target: { name: "email", value: trimmedValue },
                                                            }, spouse.id);
                                                        }

                                                        // Check email immediately on blur (only if Living)
                                                        if (trimmedValue && spouse.aliveStatus === "1") {
                                                            checkEmailExists(trimmedValue, `additional-${spouse.id}`);
                                                        }

                                                        setTouchedFields((prev) => ({
                                                            ...prev,
                                                            spouse: {
                                                                ...prev.spouse,
                                                                email: true,
                                                            },
                                                        }));
                                                    }}
                                                    disabled={spouse.aliveStatus === "2"}
                                                />
                                    </>
                                    {additionalSpouseErrors[spouse.id]?.email &&
                                        (touchedFields.spouse.email || formSubmitted) && (
                                            <div
                                                style={{
                                                    color: "#d32f2f",
                                                    fontSize: "12px",
                                                    marginTop: "4px",
                                                }}
                                            >
                                                {additionalSpouseErrors[spouse.id].email}
                                            </div>
                                        )}
                                </div>

                                <div className="form-group addmember-form-group">
                                    <label>Cell Type</label>
                                    <DropdownSelect
                                        options={sortedCellTypeOptions}
                                        value={spouse.phone_type}
                                        onChange={(val) => {
                                            const fakeEvent = {
                                                target: { name: "phone_type", value: val },
                                            };
                                            handleAdditionalSpouseChange(fakeEvent, spouse.id);
                                        }}
                                        placeholder="Select cell type"
                                        maxMenuHeight={88}
                                        disabled={spouse.aliveStatus === "2"}
                                    />
                                </div>

                                <div className="form-group addmember-form-group">
                                    <label className="">Cell Number </label>
                                    <PhoneInput
                                        country={"us"}
                                        value={getPhoneInputValue(
                                            spouse.phone,
                                            spouse.countryCode
                                        )}
                                        placeholder=""
                                        {...phoneInputCountrySearchProps}
                                        onChange={(value, country) =>
                                            handleAdditionalSpousePhoneChange(value, country, spouse.id)
                                        }
                                        disabled={spouse.aliveStatus === "2"}
                                        // onChange={(value, country) => {
                                        //   const dialCode = `+${country.dialCode}`;
                                        //   const trimmed = value.trim();
                                        //   const match = trimmed.match(/^(\+\d{1,3})\s*(.*)$/);
                                        //   const extractedCountryCode = match
                                        //     ? match[1]
                                        //     : dialCode;
                                        //   const phoneNumber = match ? match[2] || "" : trimmed;

                                        //   setAdditionalSpouses((prev) =>
                                        //     prev.map((s) =>
                                        //       s.id === spouse.id
                                        //         ? {
                                        //             ...s,
                                        //             phone: phoneNumber,
                                        //             countryCode: extractedCountryCode,
                                        //           }
                                        //         : s
                                        //     )
                                        //   );
                                        // }}
                                        inputStyle={{
                                            width: "100%",
                                            height: "47px",
                                            minHeight: "47px",
                                            backgroundColor: spouse.aliveStatus === "2" ? "#f5f5f5" : "white",
                                            opacity: spouse.aliveStatus === "2" ? 0.6 : 1,
                                            cursor: spouse.aliveStatus === "2" ? "not-allowed" : "text",
                                            // paddingLeft: "48px",
                                        }}
                                        containerStyle={{
                                            marginBottom: "0",
                                        }}
                                        inputProps={{
                                            name: "phone",
                                        }}
                                    />
                                </div>

                                {/* <div className="form-group addmember-form-group">
                      <label>Relation to Top of the Line</label>
                      <input
                        type="text"
                        name="relation"
                        // value={spouse.relation}
                        value={grandmotherData.relation || spouse.relation}
                        readOnly
                      />
                    </div> */}

                                {/* Wedding Anniversary — full width row when divorced "Yes" */}
                                {grandfatherData.maritalStatus != 1 && spouse.divorce == 1 && (
                                    <div
                                        className="form-group addmember-form-group"
                                        style={{ gridColumn: "1 / -1" }}
                                    >
                                        <label
                                            className={
                                                skipMaritalFieldRequirements ? "" : "required-label"
                                            }
                                        >
                                            Wedding Anniversary
                                        </label>
                                        <CustomDatePicker
                                            value={isInRelationship ? "" : spouse.wedding_anniversary}
                                            onChange={(e) => handleAdditionalSpouseChange(e, spouse.id, index)}
                                            name="wedding_anniversary"
                                            format={ADD_MEMBER_DATE_FORMAT}
                                            autoFocusNextOnComplete
                                            required={!skipMaritalFieldRequirements}
                                            disabled={isInRelationship}
                                            error={
                                                !!dateValidationErrors?.additional_spouse?.[index]?.wedding_anniversary &&
                                                (touchedFields?.additional_spouse?.[index]?.wedding_anniversary || formSubmitted)
                                            }
                                            helperText={
                                                (touchedFields?.additional_spouse?.[index]?.wedding_anniversary || formSubmitted)
                                                    ? dateValidationErrors?.additional_spouse?.[index]?.wedding_anniversary
                                                    : ""
                                            }
                                        />
                                    </div>
                                )}

                                <div
                                    className={
                                        spouse.divorce == 1
                                            ? "addmember-divorce-triple-row"
                                            : undefined
                                    }
                                >
                                    <div
                                        id={`additional-spouse-divorce-field-${spouse.id}`}
                                        className="form-group addmember-form-group"
                                    >
                                        <label
                                            className={
                                                spouse.aliveStatus == 2 ||
                                                skipMaritalFieldRequirements
                                                    ? ""
                                                    : "required-label"
                                            }
                                        >
                                            Divorced?
                                        </label>
                                        <DropdownSelect
                                            options={sortedDivorceOptions}
                                            value={isInRelationship ? "" : spouse.divorce}
                                            onChange={(val) => {
                                                const fakeEvent = {
                                                    target: { name: "divorce", value: val },
                                                };
                                                handleAdditionalSpouseChange(fakeEvent, spouse.id);
                                                if (val) {
                                                    setAdditionalSpouseErrors((prev) => ({
                                                        ...prev,
                                                        [spouse.id]: { ...prev[spouse.id], divorce: "" },
                                                    }));
                                                }
                                            }}
                                            onBlur={() => {
                                                setTouchedFields((prev) => ({
                                                    ...prev,
                                                    spouse: {
                                                        ...prev.spouse,
                                                        divorce: true,
                                                    },
                                                }));
                                            }}
                                            placeholder="Select your divorce status"
                                            maxMenuHeight={88}
                                            disabled={isInRelationship}
                                        />
                                        {spouse.aliveStatus != 2 &&
                                            !skipMaritalFieldRequirements &&
                                            additionalSpouseErrors[spouse.id]?.divorce &&
                                            (touchedFields.spouse.divorce || formSubmitted) && (
                                                <div
                                                    style={{
                                                        color: "#d32f2f",
                                                        fontSize: "12px",
                                                        marginTop: "4px",
                                                    }}
                                                >
                                                    {additionalSpouseErrors[spouse.id].divorce}
                                                </div>
                                            )}
                                    </div>

                                    {spouse.divorce == 1 && (
                                        <>
                                            <div className="form-group addmember-form-group">
                                                <label>Divorce Date</label>
                                                <CustomDatePicker
                                                    value={spouse.divorce_date}
                                                    onChange={(e) =>
                                                        handleAdditionalSpouseChange(e, spouse.id, index)
                                                    }
                                                    name="divorce_date"
                                                    format={ADD_MEMBER_DATE_FORMAT}
                                                    autoFocusNextOnComplete
                                                    required={false}
                                                    error={
                                                        !!dateValidationErrors?.additional_spouse?.[index]?.divorce_date &&
                                                        (touchedFields?.additional_spouse?.[index]?.divorce_date || formSubmitted)
                                                    }
                                                    helperText={
                                                        touchedFields?.additional_spouse?.[index]?.divorce_date || formSubmitted
                                                            ? dateValidationErrors?.additional_spouse?.[index]?.divorce_date
                                                            : ""
                                                    }
                                                />
                                            </div>
                                            <div className="form-group addmember-form-group">
                                                <label>Time Married</label>
                                                <input
                                                    type="text"
                                                    name="marriedYears"
                                                    value={spouse.marriedYears || ""}
                                                    readOnly
                                                    placeholder="Auto calculated"
                                                    style={{ backgroundColor: "#f0f0f0" }}
                                                />
                                            </div>
                                        </>
                                    )}
                                </div>

                                {/* Multiple Births Field */}
                                {/* <div className="col-sm-6 form-group addmember-form-group">
                      <label>Multiple births</label>
                      <DropdownSelect
                        options={[
                          { value: "Twins", label: "Twins" },
                          { value: "Triplets", label: "Triplets" },
                          { value: "Quadruplets", label: "Quadruplets" },
                          { value: "Quintuplets", label: "Quintuplets" },
                          { value: "Sextuplets", label: "Sextuplets" },
                          { value: "Septuplets", label: "Septuplets" },
                          { value: "Octuplets", label: "Octuplets" },
                          { value: "Nuntuplets", label: "Nuntuplets" },
                        ]}
                        value={spouse.multiple_births_type}
                        onChange={(val) => {
                          const fakeEvent = {
                            target: {
                              name: "multiple_births_type",
                              value: val,
                            },
                          };
                          handleAdditionalSpouseChange(fakeEvent, spouse.id);
                        }}
                        placeholder="Multiple births"
                        maxMenuHeight={88}
                      />
                    </div> */}

                                <div
                                    className="col-sm-12 form-group addmember-form-group addmember-notes-stretch"
                                    style={{ gridColumn: "1 / -1" }}
                                >
                                    <label>Notes</label>
                                    <textarea
                                        name="note"
                                        value={spouse.note}
                                        onChange={(e) =>
                                            handleAdditionalSpouseChange(e, spouse.id)
                                        }
                                        rows={6}
                                        placeholder="Additional notes about the spouse..."
                                    />
                                </div>
                            </div>
                        </>
                    )}
                </div>
            );
            })}
        </>
    )
}